import React, { useRef } from 'react';
import { Row, Col, Card, FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import { useDrop, DndProvider, useDrag } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../../../Components/helper';

export function ShippingDetails({ fromForm, index, dropLocation }) {
  const { t } = useTranslation('common');

  function ShipData() {
    const ShipRef = useRef(null);

    const [{ item, handlerId, isOver }, drop] = useDrop({
      accept: 'container',
      drop: () => {
        dropLocation(index, item);
      },
      collect: (monitor) => ({
        item: monitor.getItem(),
        handlerId: monitor.getHandlerId(),
        isOver: monitor.isOver(),
      }),
    });
    const [{ itemDragging }] = useDrag({
      type: 'container',
      collect: (monitor) => ({
        itemDragging: monitor.getItem(),
      }),
    });
    drop(ShipRef);
    return (
      <div ref={ShipRef} data-handler-id={handlerId} key={`ShipData_${index}`}>
        {isOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.DROP_SELECTION_HERE')}</div>}
        <Card className="listing-card">
          <Card.Header className="py-2 px-2 bgcolor-dark">
            <strong>{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_DETAILS')}</strong>
          </Card.Header>
          {itemDragging?.type !== 'container' && (
            <Card.Body>
              <Row className="py-3">
                <Col lg={6}>
                  <FormGroup>
                    <div className="custom-react-select">
                      <label className="f-14 mb-1">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPMENT_METHOD')}</label>
                      <Select
                        name="Shipment Method"
                        isDisabled
                        styles={customStyles}
                        placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPMENT_METHOD')}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <label className="asterisk-req mb-2 f-14">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_HANDLING_COST_INCLUDED')}</label>
                    <div className="align-items-center d-flex py-1">
                      <p className="custom-radio mb-0 mx-3">
                        <input type="radio" id="radio1" name="radio1" disabled />
                        <label className="m-0" htmlFor="radio1">
                          {t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.YES')}
                        </label>
                      </p>
                      <p className="custom-radio mb-0 mx-3">
                        <input type="radio" id="radio2" name="radio2" disabled />
                        <label className="m-0" htmlFor="radio2">
                          {t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.NO')}
                        </label>
                      </p>
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <div className="input-group form-floating-label-po fixed-label">
                      <label className="asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LANDING')}</label>
                      <input type="text" placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LANDING')} className="form-control f-14" disabled />
                    </div>
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <div className="custom-react-select">
                      <label className="f-14 mb-1">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.INCOTERMS')}</label>
                      <Select name="Incoterms" isDisabled styles={customStyles} placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.INCOTERMS')} />
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <div className="input-group form-floating-label-po fixed-label">
                      <label className="asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_HANDLING_COST')}</label>
                      <input
                        type="text"
                        placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_HANDLING_COST')}
                        className="form-control f-14"
                        disabled
                      />
                    </div>
                  </FormGroup>
                  <FormGroup>
                    <div className="input-group form-floating-label-po fixed-label">
                      <label className="asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LADING')}</label>
                      <input type="text" placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LADING')} className="form-control f-14" disabled />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </Card.Body>
          )}
        </Card>
      </div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      {fromForm ? (
        <ShipData />
      ) : (
        <Card className="listing-card">
          <Card.Header className="py-2 px-2 bgcolor-dark">
            <strong>{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_DETAILS')}</strong>
          </Card.Header>
          <Card.Body>
            <Row className="py-3">
              <Col lg={6}>
                <FormGroup>
                  <div className="custom-react-select">
                    <label className="f-14 mb-1">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPMENT_METHODS')}</label>
                    <Select
                      name="Shipment Method"
                      isDisabled
                      styles={customStyles}
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPMENT_METHODS')}
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <label className="asterisk-req mb-2 f-14">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_HANDLING')}</label>
                  <div className="align-items-center d-flex py-1">
                    <p className="custom-radio mb-0 mx-3">
                      <input type="radio" id="radio1" name="radio1" disabled />
                      <label className="m-0" htmlFor="radio1">
                        {t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.YES')}
                      </label>
                    </p>
                    <p className="custom-radio mb-0 mx-3">
                      <input type="radio" id="radio2" name="radio2" disabled />
                      <label className="m-0" htmlFor="radio2">
                        {t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.NO')}
                      </label>
                    </p>
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="input-group form-floating-label-po fixed-label">
                    <label className="asterisk-req f-14"> {t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LANDINGS')}</label>
                    <input type="text" placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LANDINGS')} className="form-control f-14" disabled />
                  </div>
                </FormGroup>
              </Col>
              <Col lg={6}>
                <FormGroup>
                  <div className="custom-react-select">
                    <label className="f-14 mb-1">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_INCOTERMS')}</label>
                    <Select name="Incoterms" isDisabled styles={customStyles} placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_INCOTERMS')} />
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="input-group form-floating-label-po fixed-label">
                    <label className="asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_HANDLING_COSTS')}</label>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.SHIPPING_HANDLING_COSTS')}
                      className="form-control f-14"
                      disabled
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="input-group form-floating-label-po fixed-label">
                    <label className="asterisk-req f-14">{t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LADINGS')}</label>
                    <input type="text" placeholder={t('PO_TEMPLATES.PO_DETAILS.SHIPPING_DETAILS.PORT_OF_LADINGS')} className="form-control f-14" disabled />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </DndProvider>
  );
}

export default ShippingDetails;
